import React from "react";
import {Button} from "react-bootstrap";
import {translate} from '../../i18n/translate.js';
import styles from "../../css/account/accountNavigationHeader.less";

class AccountNavigationHeader extends React.Component {
    render() {
        const buttons = this.props.buttons;
        const left = buttons.left;
        const right = buttons.right;
        return (
            <div className={"account-navigation-header" + (this.props.fullWidth ? " full-width" : "")}>
                <div className="title">{translate(this.props.title)}</div>
                <div className="navigation-buttons">
                    {left && !left.invisible ?
                        <Button bsStyle="primary" className={"button " + left.className} onClick={left.onClick} disabled={left.disabled}>{translate(left.label)}</Button>
                        : undefined
                    }
                    {right && !right.invisible ?
                        <Button bsStyle="primary" className={"button " + right.className} onClick={right.onClick} disabled={right.disabled}>{translate(right.label)}</Button>
                        : undefined
                    }
                </div>
            </div>
        )
    }
}

export default AccountNavigationHeader;




// WEBPACK FOOTER //
// ./src/components/account/AccountNavigationHeader.js